/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitsVersionManagement } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const useEditBenefitVersion = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (bVersion: IBenefitsVersionManagement) => BenefitsService.editBenefitsVersion(bVersion),
    {
      onSuccess: () => {
        AlertAdapter('Maintain version edited', 'success');
        queryClient.invalidateQueries(['benefits-version-management']);
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
  return mutation;
};
